import type { RootState } from "@/app/store/type";

export const selectRequestModalFormData = (state: RootState) => state.modal.form;
export const selectRequestModalFormOpen = (state: RootState) => state.modal.form.open;

export const selectModalRequestComplated = (state: RootState) => state.modal.complated;

export const selectModalPresentationLink = (state: RootState) => state.modal.link;